const fetchTitles = (data) => data;

export default fetchTitles;
